import React from "react";
import { HeaderComponent } from "../header/Header.component";
import { FooterComponent } from "../footer/Footer.component";
import { BackToTopComponent } from "../back-to-top/BackToTop.component";
import { CookieBannerComponent } from "../cookie-banner/CookieBanner.component";
import { TabContainer } from "../tab-container/TabContainer.component";
import { tabs } from "../../data/tabs";
import { useMenu } from "../menu/useMenu";
import VolumetricLogo from "@assets/images/volumetric192.png";

export const AppComponent = (): React.JSX.Element => {
  const { selectedTab } = useMenu();

  return (
    <main>
      <HeaderComponent logo={VolumetricLogo} title="Volumetric Labs" />
      <TabContainer selectedTab={selectedTab} tabs={tabs} />
      <FooterComponent />
      <BackToTopComponent />
      <CookieBannerComponent />
    </main>
  );
};
